module.exports = __webpack_public_path__ + "static/media/type2-hover-4.db3d1a96.jpg";